var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"permission-container"},[_c('div',{staticClass:"permission-tips"},[_vm._v(_vm._s(_vm.description))]),_c('a-button',{staticClass:"permission-btn",attrs:{"type":"primary"},on:{"click":_vm.relogin}},[_vm._v("重新登录")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }